import { io } from 'socket.io-client';

// When REACT_APP_SOCKET_URL is not set or empty, use same origin (for Docker/nginx proxy)
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || '';

let socket = null;

export const connectSocket = () => {
  if (!socket) {
    socket = io(SOCKET_URL, {
      transports: ['polling', 'websocket'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
      timeout: 20000,
      forceNew: false,
      // Send the logged-in user's token so the server can authorize host-only
      // actions. Guest players (join by PIN) simply have no token.
      auth: { token: localStorage.getItem('token') || undefined },
    });

    socket.on('connect_error', (error) => {
      console.error('Socket.io connection error:', error);
    });
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => {
  if (!socket) {
    return connectSocket();
  }
  return socket;
};

